<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const learning_language = computed({
  get: () => localStorage.getItem('learningLanguage') || 'Simplified_Chinese',
  set: (value) => localStorage.setItem('learningLanguage', value),
})

watch(learning_language, (newVal) => {
  console.log('Language changed:', newVal)
})

const hideLayout = computed(() => route.path === '/')
</script>

<template>
  <div>
    <MainHeader v-if="!hideLayout" />
    <router-view />
    <MainFooter v-if="!hideLayout" />
  </div>
</template>